'use strict';

/**
 * Tingle Context
 * The environment for tingle's initialization
 * @author gnosaij
 *
 * Copyright 2014-2015, Tingle Team, Alinw.
 * All rights reserved.
 */

module.exports = require('./Context');
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBU0EsT0FBTyxPQUFQLEdBQWlCLFFBQVEsV0FBUixDQUFqQiIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogVGluZ2xlIENvbnRleHRcbiAqIFRoZSBlbnZpcm9ubWVudCBmb3IgdGluZ2xlJ3MgaW5pdGlhbGl6YXRpb25cbiAqIEBhdXRob3IgZ25vc2FpalxuICpcbiAqIENvcHlyaWdodCAyMDE0LTIwMTUsIFRpbmdsZSBUZWFtLCBBbGludy5cbiAqIEFsbCByaWdodHMgcmVzZXJ2ZWQuXG4gKi9cblxubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKCcuL0NvbnRleHQnKTsiXSwic291cmNlUm9vdCI6Ii9zb3VyY2UvIn0=



/*****************
 ** WEBPACK FOOTER
 ** ./~/@ali/tingle-context/dist/index.js
 ** module id = 1
 ** module chunks = 0
 **/